var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c("address-autocomplete-field", {
                attrs: {
                  label: _vm.label ? _vm.label : _vm.autoCompleteLabel,
                  "hidden-label": _vm.hiddenLabel,
                  placeholder: _vm.$t("global.actions.startTyping") + "...",
                  disabled: _vm.disabled,
                  "auto-fill": "off",
                  "auto-complete": "off",
                },
                on: { autocomplete: _vm.handleAutocomplete },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      !_vm.typeManualAddress
        ? _c(
            "b-row",
            { staticClass: "justify-content-end" },
            [
              _c(
                "b-col",
                { attrs: { cols: "auto" } },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "link" },
                      on: {
                        click: function ($event) {
                          _vm.typeManualAddress = true
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("global.actions.typeManualAddress")) +
                          "\n      "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _vm.typeManualAddress
            ? _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c("address-layout", {
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "line1",
                          fn: function () {
                            return [
                              _c("text-field", {
                                attrs: {
                                  value: _vm.line1Model,
                                  label:
                                    _vm.$t("global.doorr.addressLine") + " 1",
                                  placeholder:
                                    _vm.$t("global.doorr.addressLine") + " 1",
                                  validator: _vm.validatorFields.line1,
                                  "max-length": 35,
                                  "show-required-indicator":
                                    _vm.showRequiredIndicator,
                                },
                                on: {
                                  "update:value": function ($event) {
                                    _vm.line1Model = $event
                                  },
                                },
                              }),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "line2",
                          fn: function () {
                            return [
                              _c("text-field", {
                                attrs: {
                                  value: _vm.line2Model,
                                  label:
                                    _vm.$t("global.doorr.addressLine") + " 2",
                                  placeholder:
                                    _vm.$t("global.doorr.addressLine") + " 2",
                                  "max-length": 35,
                                  "show-required-indicator":
                                    _vm.showRequiredIndicator,
                                },
                                on: {
                                  "update:value": function ($event) {
                                    _vm.line2Model = $event
                                  },
                                },
                              }),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "unit-number",
                          fn: function () {
                            return [
                              _c("text-field", {
                                attrs: {
                                  value: _vm.unitNumberModel,
                                  label: _vm.$t("global.doorr.unitNumber"),
                                  placeholder: _vm.$t(
                                    "global.doorr.unitNumber"
                                  ),
                                  "max-length": 10,
                                  "show-required-indicator":
                                    _vm.showRequiredIndicator,
                                },
                                on: {
                                  "update:value": function ($event) {
                                    _vm.unitNumberModel = $event
                                  },
                                },
                              }),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "street-number",
                          fn: function () {
                            return [
                              _c("text-field", {
                                attrs: {
                                  value: _vm.streetNumberModel,
                                  label: _vm.$t("global.doorr.streetNumber"),
                                  placeholder: _vm.$t(
                                    "global.doorr.streetNumber"
                                  ),
                                  validator: _vm.validatorFields.streetNumber,
                                  "show-required-indicator":
                                    _vm.showRequiredIndicator,
                                  "max-length": 10,
                                  "mask-type": "number",
                                },
                                on: {
                                  "update:value": function ($event) {
                                    _vm.streetNumberModel = $event
                                  },
                                },
                              }),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "street-name",
                          fn: function () {
                            return [
                              _c("text-field", {
                                attrs: {
                                  value: _vm.streetNameModel,
                                  label: _vm.$t("global.doorr.streetName"),
                                  placeholder: _vm.$t(
                                    "global.doorr.streetName"
                                  ),
                                  validator: _vm.validatorFields.streetName,
                                  "show-required-indicator":
                                    _vm.showRequiredIndicator,
                                  "max-length": 30,
                                },
                                on: {
                                  "update:value": function ($event) {
                                    _vm.streetNameModel = $event
                                  },
                                },
                              }),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "street-direction",
                          fn: function () {
                            return [
                              _c("text-field", {
                                attrs: {
                                  value: _vm.streetDirectionModel,
                                  label: _vm.$t("global.doorr.streetDirection"),
                                  placeholder: _vm.$t(
                                    "global.doorr.streetDirection"
                                  ),
                                  "show-required-indicator":
                                    _vm.showRequiredIndicator,
                                },
                                on: {
                                  "update:value": function ($event) {
                                    _vm.streetDirectionModel = $event
                                  },
                                },
                              }),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "street-type",
                          fn: function () {
                            return [
                              _c("text-field", {
                                attrs: {
                                  value: _vm.streetTypeModel,
                                  label: _vm.$t("global.doorr.streetType"),
                                  placeholder: _vm.$t(
                                    "global.doorr.streetType"
                                  ),
                                  "show-required-indicator":
                                    _vm.showRequiredIndicator,
                                },
                                on: {
                                  "update:value": function ($event) {
                                    _vm.streetTypeModel = $event
                                  },
                                },
                              }),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "city",
                          fn: function () {
                            return [
                              _c("text-field", {
                                attrs: {
                                  value: _vm.cityModel,
                                  label: _vm.$t("global.words.city"),
                                  placeholder: _vm.$t("global.words.city"),
                                  validator: _vm.validatorFields.city,
                                  "show-required-indicator":
                                    _vm.showRequiredIndicator,
                                  "max-length": 20,
                                },
                                on: {
                                  "update:value": function ($event) {
                                    _vm.cityModel = $event
                                  },
                                },
                              }),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "province",
                          fn: function () {
                            return [
                              _c("select-field", {
                                attrs: {
                                  value: _vm.provinceModel,
                                  label: _vm.$t("global.words.province"),
                                  placeholder: _vm.$t("global.words.province"),
                                  options: _vm.canadaProvinceOptions,
                                  validator: _vm.validatorFields.province,
                                  "show-required-indicator":
                                    _vm.showRequiredIndicator,
                                },
                                on: {
                                  "update:value": function ($event) {
                                    _vm.provinceModel = $event
                                  },
                                },
                              }),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "postal-code",
                          fn: function () {
                            return [
                              _c("text-field", {
                                attrs: {
                                  value: _vm.postalCodeModel,
                                  label: _vm.$t("global.doorr.postalCode"),
                                  placeholder: _vm.$t(
                                    "global.doorr.postalCode"
                                  ),
                                  "mask-type": "can-postal",
                                  validator: _vm.validatorFields.postalCode,
                                  "show-required-indicator":
                                    _vm.showRequiredIndicator,
                                },
                                on: {
                                  "update:value": function ($event) {
                                    _vm.postalCodeModel = $event
                                  },
                                },
                              }),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      287642218
                    ),
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }